import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ChecklistEntity } from '../../domain/entities/checklist.entity';
import { ChecklistListItemEntity } from '../../domain/entities/checklist-list-item.entity';
import { ChecklistApi } from '../api/checklist.api';
import { ChecklistMapper } from '../mappers/checklist.mapper';

export interface SaveChecklistStepParams {
  id?: string | null;
  description: string;
  displayOrder: number;
}

export interface SaveChecklistParams {
  displayOnCases: boolean;
  steps: SaveChecklistStepParams[];
}

@Injectable({ providedIn: 'root' })
export class ChecklistRepository {
  private readonly _api = inject(ChecklistApi);
  private readonly _mapper = inject(ChecklistMapper);

  public getChecklist(caseTypeId: string): Observable<ChecklistEntity> {
    return this._api.getChecklist(caseTypeId).pipe(map((dto) => this._mapper.toDomain(dto)));
  }

  public saveChecklist(caseTypeId: string, params: SaveChecklistParams): Observable<ChecklistEntity> {
    return this._api.saveChecklist(caseTypeId, {
      displayOnCases: params.displayOnCases,
      steps: params.steps.map((step) => ({
        id: step.id,
        description: step.description,
        displayOrder: step.displayOrder,
      })),
    }).pipe(map((dto) => this._mapper.toDomain(dto)));
  }

  public getAllChecklists(): Observable<{ data: ChecklistListItemEntity[]; totalElements: number }> {
    return this._api.getAllChecklists().pipe(
      map((result) => ({
        data: this._mapper.toListItemDomainArray(result.data),
        totalElements: result.totalElements,
      })),
    );
  }

  public deleteChecklist(caseTypeId: string): Observable<void> {
    return this._api.deleteChecklist(caseTypeId);
  }

  public toggleChecklistDisplay(caseTypeId: string, displayOnCases: boolean): Observable<void> {
    return this._api.toggleChecklistDisplay(caseTypeId, { displayOnCases });
  }
}
